  <lm-html-url-doc #LMHtmlUrlDoc
      [isHtmlFragment]="false"
      [upToLines]="_manualRep.upToLines"
      [upToChar]="_manualRep.upToChar"
      [url]="manualRefUrl"
      [fieldManualRep]="true"
      [frameIdentifier]="frameIdentifier"
      [automationId]="automationId"
      (setFieldDirty)="onSetFieldDirty($event)"
      (contentModified)="onContentModified($event)"
      (customDocumentLoaded)="onCustomDocumentLoaded()"
  >
  </lm-html-url-doc>
